import axiosInstance from "utils/axiosInstance";
import {appUrls} from "../helpers/Urls";

export const GetAppType = () => {
    return async () => {
        const response = await axiosInstance.get(appUrls.appType);
        console.log(response)
        return response.data
    }
}